import turfFn from "@turf/boolean-contains";

export default function booleanContains(feature1, feature2) {
    return turfFn(feature1, feature2);
}
